
export enum ExadataDatabaseCd {
	ALL = 'All',
	LTLAPDEV = 'Ltlapdev',
	LTLAPTST = 'Ltlaptst',
	PRDRDRSTBYX_6 = 'Prdrdrstbyx6',
	PRDRDR_SRV = 'PrdrdrSrv'}

